import React, {useState} from 'react';
import SectionLayout from '../../../CommonComponents/Layout/sectionLayout';
import CommonJobsListingCard from '../CommonJobListing/CommonJobListingCard';
import {Button, Col, Row} from 'antd';
import CommonHeroText from '../../../CommonComponents/CommonHeroText';
import CommonAddNewListingWithFilter from '../../../CommonComponents/Common_AddNewListing_with_Filter';
import {useDispatch} from 'react-redux';
import {getAllApprovedJobs} from '../../../../Store/Actions';
import useLocalization from '../../../../Localization';
import {useNavigate} from 'react-router-dom';
import {PlusOutlined} from '@ant-design/icons';
import JobsFormComponent from '../JobsForm';
import {getLocalStorageUserInfo} from '../../../../Util/commonUtility';

const ApprovedJobListing = ({
  allApprovedJobsData,
  locationOptionsList,
  jobFeesOptions,
  zeroFeeData,
}) => {
  const {ApplicationString} = useLocalization();
  const [selectedLocationValue, setSelectedLocationValue] = useState('');
  const [filteredPosition, setFilteredPosition] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  let dispatch = useDispatch();

  const handleChange = (value) => {
    if (!value) {
      dispatch(getAllApprovedJobs());
      setSelectedLocationValue('');
    } else {
      dispatch(getAllApprovedJobs(value));
      setSelectedLocationValue(value);
    }
  };

  const handleModalOpen = () => {
    const userInfo = getLocalStorageUserInfo();
    if (!userInfo) {
      navigate('/login');
      localStorage.setItem('redirectUrl', '/jobs');
      return;
    }
    setIsModalOpen(true);
  };

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowJobsListingPage'>
        <Col span={24}>
          <CommonHeroText
            heading={
              ApplicationString['userApprovedJobsListingComponent.heading']
            }
          />
        </Col>
        <Col span={24}>
          <SectionLayout>
            <span className='jobListingPageContentHeading'>
              {ApplicationString['userApprovedJobsListingComponent.subheading']}{' '}
              {/* <a href='/jobs' target='_blank' rel='noopener noreferrer'>
                clicking here.
              </a> */}
            </span>
          </SectionLayout>
        </Col>
        <Col span={24}>
          <SectionLayout>
            <div
              style={{
                display: 'flex',
                justifyContent: 'end',
                alignItems: 'center',
                width: '100%',
                gap: '24px',
              }}>
              {setFilteredPosition && (
                <CommonAddNewListingWithFilter
                  selectedLocationValue={selectedLocationValue}
                  filteredPosition={setFilteredPosition}
                  addNew={false}
                  usedForMyEvents={false}
                  usedForMyEventsCart={false}
                  location
                  search={false}
                  status={false}
                  selectPlaceholder={
                    ApplicationString['eventListing.selectLocation']
                  }
                  categoryList={locationOptionsList}
                  handleLocationFilter={handleChange}
                  placeHolder={
                    ApplicationString['eventListing.searchByEventName']
                  }
                />
              )}
              <div className='add-new-listing-button-container-approved-ads'>
                <Button
                  type='primary'
                  id='UserJobsComponent-filterButton-addJobs'
                  prefixCls='add-new-listing-button'
                  onClick={handleModalOpen}>
                  <span className='add-new-listing-button-content'>
                    {' '}
                    {
                      ApplicationString[
                        'userComponent.button.addListing.approvedJobs'
                      ]
                    }{' '}
                  </span>
                  <div>
                    <PlusOutlined className='add-new-listing-icon' />
                  </div>
                </Button>
              </div>
            </div>
          </SectionLayout>
        </Col>

        {
          <JobsFormComponent
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            jobFeesOptions={jobFeesOptions}
            zeroFeeData={zeroFeeData}
          />
        }
        <Col span={24}>
          <SectionLayout>
            <div className='common-jobs-listing-main-container'>
              {allApprovedJobsData.map((item, index) => {
                return (
                  <CommonJobsListingCard
                    key={item?.id}
                    jobId={item?.id}
                    jobLocation={item?.location}
                    jobLastDate={item?.created_at}
                    jobEmployer={item?.employer}
                    jobTitle={item?.position}
                    jobDescription={item?.description}
                    jobStatus={item?.status}
                    months={item?.months}
                    showDeactivateButton={false}
                  />
                );
              })}
            </div>
          </SectionLayout>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default ApprovedJobListing;
